/**
 * We'll put all functionalities related to controlling app pages here
 */
class PageControl {

    vueObject = null;

    constructor(vueObject) {
        this.vueObject = vueObject;
    }

    /**
     * The sessionValue is being set to null upon logout(session expire). Force current page to redirect onto sign-in page if session is empty
     * @param {*} sessionId user's session id
     * @param {*} vueObject Vue's top level object
     * @returns N/A
     */
    validateSession(sessionId, reloadPageIntent){
        if(!sessionId) {
            if(reloadPageIntent){
                top.window.location.reload();
            } else {
                this.vueObject.$router.push("/signin");
                return;
            }
        }
    }
}

export default PageControl;
